// extracted by mini-css-extract-plugin
export default {"input_field":"EditWishlistModal_input_field__8V9SK","label_form":"EditWishlistModal_label_form__BIeO6"};